import type { Geo } from '@aws-amplify/geo';

import { LOCATION_PLACE_INDEX } from './constants';
import type { LatLong } from './LatLong';

type SearchForLocationSuggestionsResults = Awaited<
  ReturnType<typeof Geo.searchForSuggestions>
>;

export const searchForLocationSuggestions = async (
  searchTerm: string,
  bias?: LatLong,
  countries?: Array<string>
): Promise<SearchForLocationSuggestionsResults> => {
  return import('@aws-amplify/geo').then(({ Geo }) => {
    return Geo.searchForSuggestions(searchTerm, {
      countries: countries ?? ['USA'], // Alpha-3 country codes
      maxResults: 15,
      biasPosition: bias && [bias.long, bias.lat],
      searchIndexName: LOCATION_PLACE_INDEX,
    });
  });
};
